import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import axios from 'axios'
import axiosInit from "./script/axios-init.js";
import Utils from './script/utils.js'
import VueCookies from 'vue-cookies'
import designUtils from './script/design/designUtils.js'
import store from './store'

Vue.use(VueCookies)

// Vant控件
import {
  Button
} from 'vant'
import {
  Col,
  Row
} from 'vant'
import {
  Tabbar,
  TabbarItem
} from 'vant'
import {
  Grid,
  GridItem
} from 'vant'
import {
  Field
} from 'vant'
import {
  ActionSheet
} from 'vant'
import {
  Checkbox,
  CheckboxGroup
} from 'vant'
import {
  RadioGroup,
  Radio
} from 'vant'
import {
  Panel
} from 'vant'
import {
  Divider
} from 'vant'
import {
  Cell
} from 'vant'
import {
  CellGroup
} from 'vant'
import {
  Image
} from 'vant'
import {
  Dialog
} from 'vant'
import {
  Slider
} from 'vant'
import {
  Area
} from 'vant'
import {
  Tab,
  Tabs
} from 'vant'
import {
  Popup
} from 'vant'
import {
  List
} from 'vant'
import {
  NavBar
} from 'vant'
import {
  Search
} from 'vant'
import {
  Icon
} from 'vant'
import {
  Tag
} from 'vant'
import {
  Sticky
} from 'vant'
import {
  DropdownMenu,
  DropdownItem
} from 'vant'
import {
  Toast
} from 'vant'
import {
  Uploader
} from 'vant'
import {
  Loading
} from 'vant'
import {
  Overlay
} from 'vant'
import {
  ImagePreview
} from 'vant'
import {
  PullRefresh
} from 'vant'
import {
  CountDown
} from 'vant'
import {
  SwipeCell
} from 'vant'

import {
  Form
} from 'vant';
import {
  Calendar
} from 'vant';

import {
  DatetimePicker
} from 'vant';
import {
  Picker
} from 'vant';

import {
  Swipe,
  SwipeItem
} from 'vant'

import {
  NoticeBar
} from 'vant'
import {
  Collapse,
  CollapseItem
} from 'vant';
import {
  Stepper
} from 'vant';
import {
  Rate
} from 'vant'
import {
  IndexBar,
  IndexAnchor
} from 'vant';


import { Step, Steps } from 'vant';

Vue.use(IndexBar)
Vue.use(IndexAnchor)
Vue.use(Rate)
Vue.use(Stepper)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(SwipeCell)
Vue.use(CountDown)
Vue.use(PullRefresh)
Vue.use(ImagePreview)
Vue.use(Overlay)
Vue.use(Uploader)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Button)
Vue.use(Col)
Vue.use(Row)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Field)
Vue.use(ActionSheet)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Panel)
Vue.use(Divider)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Image)
Vue.use(Dialog)
Vue.use(Slider)
Vue.use(Area)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Popup)
Vue.use(List)
Vue.use(NavBar)
Vue.use(Search)
Vue.use(Icon)
Vue.use(Tag)
Vue.use(Sticky)
Vue.use(Toast)
Vue.use(Loading)
Vue.use(Form);
Vue.use(Calendar);
Vue.use(DatetimePicker);
Vue.use(Picker);
Vue.use(NoticeBar);
Vue.use(Step);
Vue.use(Steps);


/************************* 自定义组件(开始)  *************************/
import FormNormalInput from '@/components/base/form/input/FormNormalInput.js'
import FormAppendInput from '@/components/base/form/input/FormAppendInput.js'
Vue.use(FormNormalInput)
Vue.use(FormAppendInput)

import SingleSelect from '@/components/base/form/select/SingleSelect.js'
import SexSelect from '@/components/base/form/select/SexSelect.js'
import DateSelect from '@/components/base/form/select/DateSelect.js'
import BooleanSelect from '@/components/base/form/select/BooleanSelect.js'
import EmployerSelect from '@/components/base/form/select/EmployerSelect.js'
import DepartmentSelect from '@/components/base/form/select/DepartmentSelect.js'
import DepartmentUserSelect from '@/components/base/form/select/DepartmentUserSelect.js'
import DictItemSelect from '@/components/base/form/select/DictItemSelect.js'
import StaticSingleSelect from '@/components/base/form/select/StaticSingleSelect.js'
import StaticMulSelect from '@/components/base/form/select/StaticMulSelect.js'

import FormNormalUpload from '@/components/base/form/upload/FormNormalUpload.js'


Vue.use(SingleSelect)
Vue.use(SexSelect)
Vue.use(DateSelect)
Vue.use(BooleanSelect)
Vue.use(EmployerSelect)
Vue.use(DepartmentSelect)
Vue.use(DepartmentUserSelect)
Vue.use(FormNormalUpload)


Vue.use(DictItemSelect)
Vue.use(StaticSingleSelect)
Vue.use(StaticMulSelect)
/************************* 自定义组件(结束)  *************************/




/************************* 默认导航组件封装(开始)  *************************/
import HeaderBar from '@/components/base/system/HeaderBar.js'
import FooterBar from '@/components/base/system/FooterBar.js'
import ListFrame from '@/components/base/system/ListFrame.js'
Vue.use(HeaderBar)
Vue.use(FooterBar)
Vue.use(ListFrame)
/************************* 默认导航组件封装(结束)  *************************/


//table 开始
import StatusColumn from '@/components/base/table/column/StatusColumn.js'
import BaseColumn from '@/components/base/table/column/BaseColumn.js'
//table 结束

Vue.use(StatusColumn)
Vue.use(BaseColumn)

// 按钮开始
import OAButton from '@/components/base/button/OAButton/OAButton.js'
import SaveButton from '@/components/base/button/SaveButton/SaveButton.js'
Vue.use(OAButton)
Vue.use(SaveButton)
// 按钮结束

// 自定义表单控件 开始




import DesignInput from '@/components/base/design/DesignInput.js'
import DesignInputNumber from '@/components/base/design/DesignInputNumber.js'
import DesignTextarea from '@/components/base/design/DesignTextarea.js'
import DesignDate from '@/components/base/design/DesignDate.js'
import DesignSelect from '@/components/base/design/DesignSelect.js'
import DesignCheckBox from '@/components/base/design/DesignCheckBox.js'
import DesignRadio from '@/components/base/design/DesignRadio.js'
import DesignDateTime from '@/components/base/design/DesignDateTime.js'



Vue.use(DesignInput)
Vue.use(DesignInputNumber)
Vue.use(DesignTextarea)
Vue.use(DesignDate)
Vue.use(DesignSelect)
Vue.use(DesignCheckBox)
Vue.use(DesignRadio)
Vue.use(DesignDateTime)

import DesignSearchItem from '@/components/base/design/search/DesignSearchItem.js'
import DesignFormItem from '@/components/base/design/form/DesignFormItem.js'
import DesignTableColumn from '@/components/base/design/table/DesignTableColumn.js'

Vue.use(DesignSearchItem)
Vue.use(DesignFormItem)
Vue.use(DesignTableColumn)

// 自定义表单控件 结束


// 基础配置
Vue.config.productionTip = false

// 数据交互
// axios = axiosInit
Vue.prototype.$http = axiosInit
//全局
Vue.prototype.$store = store;

//注册全局混入
import mixinModel from "./script/mixin.js"
//加载进入全局
Vue.mixin(mixinModel);


// axios.defaults.baseURL = '/api'

// 公共方法
Vue.prototype.$utils = Utils
// 动态表单方法
Vue.prototype.$designUtils = designUtils


//路由拦截
// router.beforeEach(function(to, from, next) {
//   // console.log("*********to****************")
//   // console.log(to)
//   // console.log("*********from****************")
//   // console.log(from);
//   //判断当前是否存在token，存在，正常跳转，不存在，跳转至首页
//   // let token = axios.defaults.headers.common["Token"];
//   // if (!token && to.path != "/Login") {
//   //   if (to.path != "/") {
//   //     return next("/")
//   //   }
//   // }
//   next()
// })

/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
